import { useMemo } from 'react';
import useBeautyFilterStore from 'stores/beautyFilter/beautyFilterStore';

const useBeautyFilterTitle = () => {
  const store = useBeautyFilterStore();
  const { selectedItem: selectedMenuItem } = store.menu;
  const { table: beautyTable, selectedKey: selectedBeautyKey, resetSelectedKey: resetSelectedBeautyKey, resetSelectedSubKey: resetSelectedBeautySubKey } = store.beauty;
  const { table: makeupTable, selectedKey: selectedMakeupKey, resetSelectedKey: resetSelectedMakeupKey, resetSelectedSubKey: resetSelectedMakeupSubKey } = store.makeup;

  const title = useMemo(() => {
    if (selectedMenuItem.id === 'beauty' && selectedBeautyKey) {
      //뷰티 프리셋은 서브 아이템이 없어서 예외처리
      if (selectedBeautyKey !== 'preset') {
        return brsc[beautyTable[selectedBeautyKey].brscName];
      }
    }
    if (selectedMenuItem.id === 'makeup' && selectedMakeupKey) {
      // 메이크업 하이라이터는 단일 색상이라 예외처리
      if (selectedMakeupKey !== 'makeup_highlighter') {
        return brsc[makeupTable[selectedMakeupKey].brscName];
      }
    }
    return brsc[selectedMenuItem.brscName];
  }, [selectedMenuItem, selectedBeautyKey, selectedMakeupKey, beautyTable, makeupTable]);

  const isBackButtonVisible = useMemo(() => {
    if (selectedMenuItem.id === 'beauty' && selectedBeautyKey) {
      //뷰티 프리셋은 서브 아이템이 없어서 예외처리
      if (selectedBeautyKey !== 'preset') {
        return true;
      }
    }
    if (selectedMenuItem.id === 'makeup' && selectedMakeupKey) {
      // 메이크업 하이라이터는 단일 색상이라 예외처리
      if (selectedMakeupKey !== 'makeup_highlighter') {
        return true;
      }
    }
    return false;
  }, [selectedMenuItem, selectedBeautyKey, selectedMakeupKey]);

  const handleBackButtonClick = () => {
    if (selectedMenuItem.id === 'beauty') {
      resetSelectedBeautyKey();
      resetSelectedBeautySubKey();
    } else if (selectedMenuItem.id === 'makeup') {
      resetSelectedMakeupKey();
      resetSelectedMakeupSubKey();
    }
  };

  return {
    title,
    isBackButtonVisible,
    handleBackButtonClick,
  };
};

export default useBeautyFilterTitle;
